<template>
  <div class="service">
    
  </div>
</template>
<script>

export default {
  data() {
    return {
      
    };
  },
  mounted: function() {
    this.$store.dispatch("first_nav_change", "6");
  },
  computed: {},
  methods: {
    
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/service.vue